import { getDay, isAfter, isBefore } from 'date-fns';
import { useCallback } from 'react';
import { useIntl } from '../../../../../theme/i18n';
import { convertDateToStringRepresentation, isHoliday as _isHoliday, useDateUtils } from '../../../../../utils';
export var useDaysUtilities = _ref => {
  var {
    excludeHolidays = false,
    minDate,
    maxDate,
    weekDays
  } = _ref;
  var {
    timeZone
  } = useIntl();
  var {
    createDate
  } = useDateUtils();

  var wrap = d => createDate(convertDateToStringRepresentation(d));

  var isBeforeMinDate = useCallback(date => !!minDate && isBefore(wrap(date), wrap(minDate)), [minDate] // eslint-disable-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `wrap` function
  );
  var isAfterMaxDate = useCallback(date => !!maxDate && isAfter(wrap(date), wrap(maxDate)), [maxDate] // eslint-disable-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `wrap` function
  );
  var isHoliday = useCallback(date => excludeHolidays && _isHoliday(date, timeZone), [excludeHolidays] // eslint-disable-line react-hooks/exhaustive-deps -- we want to avoid unnecessary re-renders caused by the `timeZone` variable
  );
  var isInWeekDays = useCallback(date => !weekDays || weekDays.includes(getDay(date)), [weekDays]);
  return {
    isBeforeMinDate,
    isAfterMaxDate,
    isHoliday,
    isInWeekDays
  };
};
//# sourceMappingURL=useDaysUtilities.js.map